import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Flex, Checkbox, Button, Icon } from '@haldor/ui';
import { connect } from 'react-redux';
import { getConsentInfo, updateTenantServiceConsent, isConsentPresent } from '../../../actions/services';
import { Spinner } from 'UI';
import Redirect from 'components/Redirect/Redirect';
import { appInsights } from 'lib/appInsights';
import * as microsoftTeams from "@microsoft/teams-js";
import getEnvironment from 'lib/env';
import { getTenant } from 'actions/user';

var ConsentConfirm = /*#__PURE__*/function (_Component) {
  _inherits(ConsentConfirm, _Component);

  var _super = _createSuper(ConsentConfirm);

  function ConsentConfirm(props) {
    var _this;

    _classCallCheck(this, ConsentConfirm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderRedirect", function () {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: _this.state.redirect
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(2).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      title: 'Haldor',
      consentInfos: [],
      loading: false
    };
    return _this;
  }

  _createClass(ConsentConfirm, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Tab configure", this.props);
                appInsights.trackTrace({
                  message: "Onboarding | Initiated last step in the proccess"
                });
                _context.next = 4;
                return this.props.getTenant();

              case 4:
                this.setState({
                  loading: false
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "onSave",
    value: function onSave() {
      var _this2 = this;

      this.setState({
        showErrorMessage: null
      });
      var allConsented = this.props.consentInfo.every(function (consentInfo) {
        var matchingService = _this2.props.tenantServices.find(function (ts) {
          return ts.ServiceId === consentInfo.ServiceId;
        });

        return matchingService && matchingService.Consented !== null;
      });

      if (allConsented) {
        if (!this.inIframe()) {
          console.log("NOT teams: url", window.location.origin);
          window.location.href = window.location.origin;
        } else {
          microsoftTeams.pages.getConfig().then(function (settings) {
            if (settings.contentUrl != null) {
              var endpoint = settings.contentUrl.replace(window.location.origin, "");

              _this2.setState({
                redirect: endpoint
              });
            }
          });
        }
      } else {
        this.setState({
          showErrorMessage: this.props.translate('If you need any help or have any questions about the approval of permissions, please contact our support at support@haldor.se')
        });
      }
    }
  }, {
    key: "showButtonGroup",
    value: function showButtonGroup() {
      if (this.inIframe()) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
          type: "primary",
          style: {
            marginRight: '0.5rem'
          },
          onClick: this.onSave.bind(this)
        }, this.props.translate('Continue')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.redirect) {
        return this.renderRedirect();
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var product = getEnvironment().id;
      var productName = 'Haldor Education';

      if (product === 'haldor_planning') {
        productName = "Haldor Planning";
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#FFF'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '98%',
          paddingTop: '3%',
          paddingBlockStart: '3%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 2
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('{0} is approved').replace('{0}', productName)), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1.0rem',
          marginBottom: '1.0rem'
        }
      }, this.props.translate('The user that requested the consent will be informed that the application is approved and will be able to use the extended functionality.')), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1.0rem',
          marginBottom: '1.0rem'
        }
      }, this.props.translate('Thank you!')))), /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          marginBottom: '0,5rem',
          marginTop: '0,5rem'
        }
      }, this.state.showErrorMessage ? this.state.showErrorMessage : null), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "left",
          justifyContent: "left",
          marginTop: '1.5rem'
        }
      }, this.showButtonGroup()), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '20rem',
          height: '20rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_steg06.svg"
      }))));
    }
  }]);

  return ConsentConfirm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    consentInfo: state.Services.consentInfo,
    isAppConsented: state.Services.isAppConsented,
    onboardingUser: state.user.onboardingUser,
    tenantServices: state.Services.tenantServices
  };
}

export default connect(mapStateToProps, {
  getTenant: getTenant
})(ConsentConfirm);